import React, { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getCycle, updateCycle, createCycle, reset } from './cycle.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { ScoringMode, scoringModeLabels } from 'app/shared/model/cycle.model';

export const CycleUpdate = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId?: string; id: string }>) => {
  const dispatch = useAppDispatch();
  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const cycleEntity = useAppSelector(state => state.cycle.entity);
  const loading = useAppSelector(state => state.cycle.loading);
  const updating = useAppSelector(state => state.cycle.updating);
  const updateSuccess = useAppSelector(state => state.cycle.updateSuccess);

  const { ecoleid, anneeScolaireId, id } = props.match.params;
  const fromConfig = new URLSearchParams(props.location.search || '').get('fromConfig') === '1';

  const handleClose = () => {
    if (fromConfig) {
      props.history.push(`/configuration-pedagogie/${ecoleid}`);
      return;
    }
    props.history.push(anneeScolaireId ? `/cycle/${ecoleid}/${anneeScolaireId}` : `/cycle/${ecoleid}/`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getCycle(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...cycleEntity,
      ...values,
      ecoleId: ecoleid,
    };
    if (isNew) {
      dispatch(createCycle(entity));
    } else {
      dispatch(updateCycle(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...cycleEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="korischoolApp.cycle.home.createOrEditLabel" data-cy="CycleCreateUpdateHeading">
            <Translate contentKey="korischoolApp.cycle.home.createOrEditLabel">Create or edit a Cycle</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="cycle-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('korischoolApp.cycle.nom')} id="cycle-nom" name="nom" data-cy="nom" type="text" />
              <ValidatedField
                label={translate('korischoolApp.cycle.scoringMode')}
                id="cycle-scoringMode"
                name="scoringMode"
                data-cy="scoringMode"
                type="select"
                validate={{ required: { value: true, message: translate('entity.validation.required') } }}
              >
                <option value="" key="0" />
                {Object.values(ScoringMode).map(type => (
                  <option value={type} key={type}>
                    {scoringModeLabels[type]}
                  </option>
                ))}
              </ValidatedField>
              <Button onClick={handleClose} id="cancel-save" data-cy="entityCreateCancelButton" color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                style={{ backgroundColor: '#F28E19', color: 'white' }}
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CycleUpdate;
